<!--
 * @Author: YuanYuan
 * @Date: 2024-02-23 17:43:59
 * @LastEditTime: 2024-02-27 18:32:07
 * @description: 左右分布操作栏
-->
<template>
  <div class="tool-bar" :style="{marginBottom: bottomGap + 'px'}">
    <el-space :size="leftGapSize">
      <slot></slot>
    </el-space>
    <div v-if="hasRightSlot">
      <el-space :size="rightGapSize">
        <slot name="right"></slot>
      </el-space>
    </div>
  </div>
</template>

<script setup>
import { toRefs, computed, getCurrentInstance } from 'vue'

const $vm = getCurrentInstance().proxy

const props = defineProps({
  bottomGap: {
    type: Number,
    default: 12
  },
  gapSize: [Number, Number]
})

const { bottomGap, gapSize } = toRefs(props)

const leftGapSize = computed(() => {
  if (Array.isArray(gapSize.value)) {
    return gapSize.value[0]
  } else {
    return gapSize.value
  }
})

const rightGapSize = computed(() => {
  if (Array.isArray(gapSize.value)) {
    return gapSize.value[1]
  } else {
    return gapSize.value
  }
})

const hasRightSlot = computed(() => $vm.$slots && $vm.$slots.right && $vm.$slots.right.length)
</script>

<style lang="scss" scoped>
.tool-bar{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
